import React, {
    PropTypes,
} from 'react';
import {MenuSummary, MenuItem} from './';
import {Table, Panel, Glyphicon} from 'react-bootstrap';

const OldMenu = ({saleTimes, date}) => {
    if (saleTimes.length === 0) return null;
    const renderedSt = saleTimes.map(st =>
        <Panel
            header={<div><h4>{st.saleTimeName + ' - ' + st.locationName}</h4></div>}
            footer={
                <div className="row"><MenuSummary wares={st.wares}/></div>
            }
        >
            <Table condensed hover className="mb0 my-table">
                <thead>
                <tr>
                    <th>Блюдо</th>
                    <th className="hidden-xs hidden-sm"><Glyphicon glyph="scale"/></th>
                    <th className="hidden-xs">₴</th>
                    <th className="text-center">Количество</th>
                    <th className="hidden-xs">Итого</th>
                </tr>
                </thead>
                <tbody>
                {st.wares.map(ware =>
                    <MenuItem {...ware} />
                )}
                </tbody>
            </Table>
        </Panel>
    );
    return (
        <div>
            <h3>Ваши заказы, сделанные на дату {date}:</h3>
            {renderedSt}
        </div>
    );
};

OldMenu.propTypes = {
    saleTimes: PropTypes.array.isRequired,
    date: PropTypes.string.isRequired,
};

export default OldMenu;



/** WEBPACK FOOTER **
 ** ./src/modules/food/OldMenu.js
 **/